Application = require('resources/assets/coffee/Core/Application').Application

class exports.PortalApp extends Application
